<template>
  <div
    class="dynamic-control-container"
  >
    <div
      v-for="control in configFields"
      :key="control.position"
      :class="[$style.controlContainer, control.name]"
      :data-entry-key="control.name"
    >
      <transition :name="$style.slideTransition">
        <component
          :is="ControlTypeConsts[control.displayType]"
          v-if="showControl(control)"
          v-show="!isControlHidden(control)"
          :control="control"
          :handleValueChange="handleValueChange"
          :sensitive="control.sensitive"
          :value="findControlValue(control)"
          @radio-change="toggleRadioGroup"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { find } from 'underscore';
import { get } from 'lodash';
import DynamicControlsCheckbox from 'client/components/DynamicControls/BodyComponents/DynamicControlsCheckbox.vue';
import DynamicControlsComboBox from 'client/components/DynamicControls/BodyComponents/DynamicControlsComboBox.vue';
import DynamicControlsCopyWell from 'client/components/DynamicControls/BodyComponents/DynamicControlsCopyWell.vue';
import DynamicControlsCustomDropDown from 'client/components/DynamicControls/BodyComponents/DynamicControlsCustomDropDown.vue';
import DynamicControlsDoubleListBox from 'client/components/DynamicControls/BodyComponents/DynamicControlsDoubleListBox.vue';
import DynamicControlsDropDown from 'client/components/DynamicControls/BodyComponents/DynamicControlsDropDown.vue';
// eslint-disable-next-line max-len
import { ControlDefaultValuesConsts, ControlTypeConsts } from 'client/components/DynamicControls/constants/DynamicControlsConstants';
import DynamicControlsFileInput from 'client/components/DynamicControls/BodyComponents/DynamicControlsFileInput.vue';
import DynamicControlsInput from 'client/components/DynamicControls/BodyComponents/DynamicControlsInput.vue';
import DynamicControlsRadioGroup from 'client/components/DynamicControls/BodyComponents/DynamicControlsRadioGroup.vue';
import DynamicControlsSegmentedButton from 'client/components/DynamicControls/BodyComponents/DynamicControlsSegmentedButton.vue';
import DynamicControlsSingleListBox from 'client/components/DynamicControls/BodyComponents/DynamicControlsSingleListBox.vue';
import DynamicControlsSpinnerInput from 'client/components/DynamicControls/BodyComponents/DynamicControlsSpinnerInput.vue';
import DynamicControlsTable from 'client/components/DynamicControls/BodyComponents/DynamicControlsTable.vue';
import DynamicControlsTextarea from 'client/components/DynamicControls/BodyComponents/DynamicControlsTextarea.vue';

export default {
  name: 'DynamicControls',

  components: {
    DynamicControlsCheckbox,
    DynamicControlsComboBox,
    DynamicControlsCopyWell,
    DynamicControlsCustomDropDown,
    DynamicControlsDoubleListBox,
    DynamicControlsDropDown,
    DynamicControlsInput,
    DynamicControlsRadioGroup,
    DynamicControlsSegmentedButton,
    DynamicControlsSingleListBox,
    DynamicControlsSpinnerInput,
    DynamicControlsTextarea,
    DynamicControlsFileInput,
    DynamicControlsTable,
  },

  inject: ['$validator'],

  props: {
    configFields: {
      required: true,
      type: Array,
    },
    configValues: {
      required: true,
      type: Array,
    },
    handleValueChange: {
      required: true,
      type: Function,
    },
    sectionId: {
      default: null,
      type: String,
    },
  },

  data() {
    return {
      ControlTypeConsts,
    };
  },

  methods: {
    findControlValue(control) {
      // eslint-disable-next-line
      const value = this.configValues.find((configValue) => {
        if (configValue.configFieldID === control.id) return true;
      });

      const defaultValue = control.defaultValue
        ? control.defaultValue
        : ControlDefaultValuesConsts[ControlTypeConsts[control.displayType]];

      return value ? value.value : defaultValue;
    },

    getDynamicControl(displayType) {
      return this.$children
        .filter(child => child.control.displayType === displayType);
    },

    isControlHidden(control) {
      return control.hide || get(control, 'displayOptions.hidden', false);
    },

    showControl(control) {
      let showControl = true;
      const { displayOptions } = control;

      if (!this.ControlTypeConsts[control.displayType]) {
        showControl = false;
      }

      const child = get(displayOptions, 'group.child');
      const section = get(displayOptions, 'group.section.id');
      if (this.sectionId && section !== this.sectionId) {
        showControl = false;
      } else if (child) {
        const parentConfig = find(this.configFields, config => get(config, 'displayOptions.group.parent') === child);
        if (parentConfig) {
          const conditionalParentValues = get(displayOptions, 'group.values', []);
          const parentValue = this.findControlValue(parentConfig);
          const childValue = this.findControlValue(control);

          if (!parentValue) {
            if (childValue !== control.defaultValue) {
              this.handleValueChange(control.id, control.defaultValue);
            }
            showControl = false;
          }

          if (conditionalParentValues.length > 0
            && !conditionalParentValues.includes(parentValue)) {
            showControl = false;
          }
        }
      }

      return showControl;
    },

    toggleRadioGroup(control) {
      const group = this.configFields
        .filter(field => field.displayOptions.group.id === control.displayOptions.group.id);

      group.forEach((member) => {
        if (member.id !== control.id) {
          this.handleValueChange(member.id, false);
        }
      });
    },

    updateControl(state) {
      Object.assign(this.configFields.find(x => x.id === state.id), state);
    },

    updateControlValue(state) {
      Object.assign(this.configValues.find(x => x.configFieldID === state.configFieldID), state);
    },
  },
};
</script>
<style module>
@value (slowEaseFade) from '~css/transitions.css';

.controlContainer {
  margin-bottom: 20px;
}

.slideTransition,
.slideTransition-enter-active,
.slideTransition-leave-active {
  transition: slowEaseFade;
}

.slideTransition-enter,
.slideTransition-leave-to {
  opacity: 0;
  transform: translateY(-1em);
}
</style>
